<template>
  <Container type="card-full">
    <el-form ref="form" label-position="left" label-width="100px">
      <el-form-item v-for="(field, index) in docgencols" v-if="field.docgencolisfilter"
                    :label="field.dsfieldname"
                    :key="field.dsfieldcode"
                    :rules="{}">
        <el-select style="width: 100px" v-model="field.filterexpr"  :clearable="true">
          <el-option v-for="(item, index) in filters" :label="item.label" :value="item.value" :key="index"></el-option>
        </el-select>
        <el-input style="width: 200px" v-model="field.value" v-if="field.dsfieldeditflg === '2' && field.dsfieldtype !== 'D' && field.dsfieldtype !== 'T'"></el-input>
        <el-date-picker  style="width: 200px"  v-model="field.value" v-if="field.dsfieldeditflg === '2' && field.dsfieldtype === 'D'" type="date" placeholder="选择日期" ></el-date-picker>
        <el-date-picker  style="width: 200px"  v-model="field.value" v-if="field.dsfieldeditflg === '2' && field.dsfieldtype === 'T'" type="datetime" placeholder="选择日期时间" ></el-date-picker>
        <el-select style="width: 200px" v-if="field.dsfieldeditflg === '3'" v-model="field.value"  :clearable="true">
          <el-option v-for="(item, index) in field.selectdata" :label="item.label" :value="item.value" :key="index"></el-option>
        </el-select>
        <span v-if="field.filterexpr === 'JY'">
              <span>至</span>
              <el-input style="width: 200px"  v-model="field.value1" v-if="field.dsfieldeditflg === '2' && field.dsfieldtype !== 'D' && field.dsfieldtype !== 'T'"></el-input>
              <el-date-picker style="width: 200px"  v-model="field.value1" v-if="field.dsfieldeditflg === '2' && field.dsfieldtype === 'D'" type="date" placeholder="选择日期" ></el-date-picker>
              <el-date-picker style="width: 200px"  v-model="field.value1" v-if="field.dsfieldeditflg === '2' && field.dsfieldtype === 'T'" type="datetime" placeholder="选择日期时间" ></el-date-picker>
              <el-select style="width: 200px" v-if="field.dsfieldeditflg === '3'" v-model="field.value1"  :clearable="true">
                <el-option v-for="(item, index) in field.selectdata" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </span>
      </el-form-item>
    </el-form>
    <el-form>
      <el-form-item label="">
        <el-button @click="requery">查询</el-button>
        <el-button @click="save" :loading="btnLoading">保存</el-button>
        <el-button @click="close">关闭</el-button>
      </el-form-item>
    </el-form>
    <vggrid ref="genGrid" :list="list" tableheight="700" :flexname="form.flexname"
            :showfooter="false":showPage="false" :resizable="true"
            :needRowNum="true" :needSelection="true"
            :needBlackRow="false" :needPopMenu="false" :canbeEdit="true">
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'docgenForm',
    data () {
      return {
        form: this.$route.params.form,
        btnLoading: false,
        docgencols: [],
        docgensql: '',
        list: [],
        filters: [
          {value: 'EQ', label: '等于'},
          {value: 'NE', label: '不等于'},
          {value: 'GT', label: '大于'},
          {value: 'LT', label: '小于'},
          {value: 'GE', label: '大于等于'},
          {value: 'LE', label: '小于等于'},
          {value: 'JY', label: '介于'},
          {value: 'AL', label: '前匹配'},
          {value: 'BL', label: '后匹配'},
          {value: 'LK', label: '包含'}
        ]
      }
    },
    async created () {
    },
    activated() {
      this.init()
      this.genGenForm()
      //this.getPageList()
    },
    mounted () {
    },
    watch: {
    },
    components: {vggrid},
    methods: {
      async init () {
        this.form = this.$route.params.form,
        this.list = []
        this.docgencols = []
        this.docgensql = ''
      },
      async close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: this.form.returnForm})
      },
      //构造生成程序的相关信息
      async genGenForm () {
        let data = await request({
          url: '/kfgl/docgen/getDocgencolByDocflexcode',
          method: "get",
          params: {flexcode: this.form.flexname,docgencode: this.form.docgencode}
        })
        await (async () => {
          for (let i = 0; i < data.length; i++) {
            let item = data[i]
            if (item.dsfieldeditflg === '2') {
              data[i].value = ''
              data[i].value1 = ''
              data[i].filterexpr = 'EQ'
              if (item.dsfieldtype === 'D' || item.dsfieldtype === 'T') {
                data[i].filterexpr = 'JY'
              }
            }
            if (item.dsfieldeditflg === '3') {
              let res = await request({
                method: 'get',
                url: '/kfgl/brows/getBrowsDataList',
                params: ({comid: this.$store.getters.loginUser.usercomid, browscode: item.dsfieldbrows})
              })
              res.splice(0, 0, {
                label: '请选择',
                value: 0
              })
              data[i].filterexpr = 'EQ'
              data[i].selectdata = res
              data[i].value = 0
              data[i].value1 = 0
            }
          }
        })()
        this.docgencols = data
      },
      async requery () {
        //先组装查询语句
        let item = {}
        let select = '',from  = '',where = '',orderby = '',having = '',groups = '',sums = '',kzwhere = '',filterstr = ''
        await (async ()=>{
          for (let i=0;i<this.docgencols.length;i++) {
            item = this.docgencols[i]
            if (i ===0) {
              select = item.docgenselect
              from  = item.docgenfrom
              where = item.docgenwhere
              orderby = item.docgenorderby
            }
            if (item.docgencolisfilter === '1' && (item.value || item.value1)) {
              switch (item.filterexpr) {
                case 'EQ'://等于
                  switch (item.dsfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.dsfieldexpr + ' = \'' + item.value + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.dsfieldexpr + ' = ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.dsfieldexpr + ' = convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.dsfieldexpr + ') = convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'NE'://不等于
                  switch (item.dsfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.dsfieldexpr + ' <> \'' + item.value + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.dsfieldexpr + ' <> ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.dsfieldexpr + ' <> convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.dsfieldexpr + ') <> convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'GT'://大于
                  switch (item.dsfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.dsfieldexpr + ' > \'' + item.value + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.dsfieldexpr + ' > ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.dsfieldexpr + ' > convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.dsfieldexpr + ') > convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'LT'://小于
                  switch (item.dsfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.dsfieldexpr + ' < \'' + item.value + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.dsfieldexpr + ' < ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.dsfieldexpr + ' < convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.dsfieldexpr + ') < convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'GE'://大于等于
                  switch (item.dsfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.dsfieldexpr + ' >= \'' + item.value + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.dsfieldexpr + ' >= ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.dsfieldexpr + ' >= convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.dsfieldexpr + ') >= convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'LE'://小于等于
                  switch (item.dsfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.dsfieldexpr + ' <= \'' + item.value + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.dsfieldexpr + ' <= ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.dsfieldexpr + ' <= convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.dsfieldexpr + ') <= convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'JY'://介于
                  switch (item.dsfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.dsfieldexpr + ' >= \'' + item.value + '\''
                      filterstr += ' and ' + item.dsfieldexpr + ' <= \'' + item.value1 + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.dsfieldexpr + ' >= ' + item.value
                      filterstr += ' and ' + item.dsfieldexpr + ' <= ' + item.value1
                      break
                    case 'D':
                      filterstr += ' and ' + item.dsfieldexpr + ' >= convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      filterstr += ' and ' + item.dsfieldexpr + ' <= convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.dsfieldexpr + ') >= convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      filterstr += ' and convert(datetime,' + item.dsfieldexpr + ') <= convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'AL'://前匹配
                  switch (item.dsfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.dsfieldexpr + ' like \'' + item.value + '%\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.dsfieldexpr + ' like ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.dsfieldexpr + ' like convert(date,\'' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '%\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.dsfieldexpr + ') like convert(datetime,\'' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '%\')'
                      break
                  }
                  break
                case 'BL'://后匹配
                  switch (item.dsfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.dsfieldexpr + ' like \'%' + item.value + '\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.dsfieldexpr + ' like ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.dsfieldexpr + ' like convert(date,\'%' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.dsfieldexpr + ') like convert(datetime,\'%' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '\')'
                      break
                  }
                  break
                case 'LK'://包含
                  switch (item.dsfieldtype) {
                    case 'C':
                      filterstr += ' and ' + item.dsfieldexpr + ' like \'%' + item.value + '%\''
                      break
                    case 'L':
                    case 'N':
                    case 'B':
                    case 'F':
                      filterstr += ' and ' + item.dsfieldexpr + ' like ' + item.value
                      break
                    case 'D':
                      filterstr += ' and ' + item.dsfieldexpr + ' like convert(date,\'%' + utils.formatterDate(item.value,'yyyy-MM-dd')+ '%\')'
                      break
                    case 'T':
                      filterstr += ' and convert(datetime,' + item.dsfieldexpr + ') like convert(datetime,\'%' + utils.formatterDate(item.value,'yyyy-MM-dd HH:mm:ss')+ '%\')'
                      break
                  }
                  break
              }
            }
          }
          let wherestr = where + kzwhere
          if (wherestr){
            if (filterstr) {
              wherestr += filterstr
            }
          } else {
            if (filterstr) {
              wherestr = ' where ' + filterstr.substr(4)
            }
          }
          this.docgensql = select + from + wherestr + having + groups + orderby
        })()
        this.list = await request({
          url: '/kfgl/docgen/getDocgenDataList',
          method: "post",
          data: {comid: this.$store.getters.loginUser.usercomid,sql: this.docgensql}
        })
      },

      async save() {
        let model = {
          dochead: this.form.docform,
          docitems: {insertRecords:this.$refs.genGrid.$refs.xGrid.getSelectRecords(),updateRecords: [],removeRecords: []}
        }
        await this.addOrEdit(model)
      },
      async addOrEdit (model) {
        let data = await request({
          url: this.form.savepath,
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.close()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
